import {
  ArrowTopRightOnSquareIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import React from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

function Consultation({
  number,
  icon,
  title,
  description,
  children,
}: {
  number?: string;
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <Card className="border-gray-200 shadow-sm overflow-hidden">
      <CardHeader className="bg-gray-50 border-b border-gray-200">
        <div className="flex items-center">
          {number ? (
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-muted-foreground text-sm font-medium mr-2">
              {number}
            </span>
          ) : null}
          {icon}
          <CardTitle className="text-gray-800">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="p-6 flex flex-col gap-6">
        {description ? <CardDescription>{description}</CardDescription> : null}
        {children}
      </CardContent>
    </Card>
  );
}

function SearchButton({
  children,
  asChild,
}: {
  children?: React.ReactNode;
  asChild?: boolean;
}) {
  return (
    <div className="flex">
      <Button
        asChild={asChild}
        variant="outline"
        className="w-auto flex items-start"
      >
        {children}
      </Button>
    </div>
  );
}

function SearchIcon() {
  return <MagnifyingGlassIcon className="w-4 h-4 mr-2 text-gray-500 inline" />;
}

function OutSideLinkIcon() {
  return (
    <ArrowTopRightOnSquareIcon className="w-4 h-4 ml-2 text-gray-500 inline" />
  );
}

Consultation.Card = Consultation;
Consultation.SearchButton = SearchButton;
Consultation.SearchIcon = SearchIcon;
Consultation.OutSideLinkIcon = OutSideLinkIcon;

export { Consultation };
